export default __webpack_public_path__ + "static/media/facebook.eb118c63.svg";